import _http_v1 from "@packs/http_requests/_http_v1"
import store from "../store/store"
import toast from "@components/toast/toast";

const diagram_helper = {
    save(){
        let current_diagram = store.diagramStore.getDiagram()
        console.log('salvando isso:', current_diagram.options);

        _http_v1.request(`diagrams/${current_diagram.id}`, 'POST', {
            diagram:{
                options: {...current_diagram.options}
            }
        }).then(data=>{
            store.diagramStore.diagramUpdated()
            toast.success({text: "Informações atualizadas"})
        })
    },
    getDams(){
        let dam_ids = store.damStore.getDams().map(x=>x.id)
        return _http_v1.request('dams', 'GET', {ids: dam_ids, with_last_event: true, additional_fields: [''], custom_fields: ['last_event']}).then(data=>{
            store.damStore.setDams(data)
        })
    },
    getEvents(ids){
        return _http_v1.request('events', 'get', {ids:ids})
    },
    getLastEvents(ids){
        return _http_v1.request('events', 'get', {last_events: {eventable_ids: ids, eventable_type: 'Dam', date: store.mainConfigStore.getPeriod().start()}})
    },
    getLastHoursEvents(){
        let dams = store.damStore.getDams()
        let period = store.mainConfigStore.getPeriod()

        const addEventsToDam = event_list =>{
            dams.forEach(dam=>{
                let events = event_list.filter(x=>x.eventable.id === dam.id)
                store.damStore.setDamEvents(dam.id, events)
            })
            console.log('last hours events',event_list);
        }

        _http_v1.request('events', 'GET', {
            eventable_type: 'Dam', 
            eventable_ids:dams.map(x=>x.id),
            event_type_id: 1, //floodgates manage
            period: {start_date: period.start(), end_date: period.end()}
        }).then(event_list=>{//após receber os eventos das ultimas horas, será buscado o ultimo registro de evento anterior (ja referenciado dentro do objeto pelo id)
            let dams = store.damStore.getDams()
            let additional_ids = []
            let last_event_ids = []
            dams.forEach(dam=>{
                //filtrando por dam e sort por data
                let first = event_list.filter(x=>x.eventable.id === dam.id).sort((x,y)=>  new Date(x.start_date) - new Date(y.start_date))[0]

                //caso tenha um outro registro de evento
                if(first){
                    //caso tenha uma referencia a registro anterior
                    if(_.get(first, 'options.references.last_event_id')){
                        additional_ids.push(_.get(first, 'options.references.last_event_id'))
                    }
                    
                } else {
                    //não foram localizados eventos nas ultimas horas, procurar mais antigos
                    last_event_ids.push(dam.id)
                }
            })

            if(additional_ids.length > 0 || last_event_ids.length > 0){
                if(additional_ids.length > 0){
                    this.getEvents(additional_ids).then(data=>{
                        event_list = [...event_list, ...data]
                        addEventsToDam(event_list)
                    })
                }
                if(last_event_ids.length > 0){
                    this.getLastEvents(last_event_ids).then(data=>{
                        event_list = [...event_list, ...data]
                        addEventsToDam(event_list)
                    })
                }
                
            } else {
                addEventsToDam(event_list)
            }
            
            
        })
    },
    now(){
        return new Date()
    }
}

export default diagram_helper